module.exports = __webpack_public_path__ + "static/media/Rebecca Hathaway.0af36669.png";